import React from 'react';
import { useBusinessContext } from '../contexts/BusinessContext';

/**
 * TierBadge - Shows a small badge indicating which tier a feature belongs to
 * Only displays during trial period to help users understand feature tiers
 * 
 * Usage:
 * <TierBadge feature="route-optimization" />
 * <TierBadge tier="Pro" />
 */
const TierBadge = ({ feature, tier, className = '', size = 'sm' }) => {
  const { shouldShowTierBadges, getTierBadge } = useBusinessContext();
  
  // Get badge info either from feature key or direct tier
  let badgeInfo = null;
  
  if (feature) {
    badgeInfo = getTierBadge(feature);
  } else if (tier) {
    if (tier === 'Pro') {
      badgeInfo = {
        label: 'PRO',
        color: 'bg-blue-100 text-blue-700 border-blue-200',
        tier: 'Pro',
      };
    } else if (tier === 'Enterprise') {
      badgeInfo = {
        label: 'ENTERPRISE',
        color: 'bg-purple-100 text-purple-700 border-purple-200',
        tier: 'Enterprise',
      };
    }
  }
  
  // Don't show badge if:
  // - Not in trial (shouldShowTierBadges is false)
  // - Feature is Solo tier (no badge needed)
  // - No badge info found
  if (!shouldShowTierBadges || !badgeInfo) {
    return null;
  }
  
  const sizeClasses = {
    xs: 'text-[10px] px-1.5 py-0.5',
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
  };
  
  return (
    <span 
      className={`
        inline-flex items-center font-bold rounded-full border
        ${badgeInfo.color}
        ${sizeClasses[size] || sizeClasses.sm}
        ${className}
      `}
    >
      {badgeInfo.label}
    </span>
  );
};

export default TierBadge;